<template>
  <el-dialog title="Gov Feedback" :close-on-click-modal="false" :visible.sync="visible" width="1000px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top">
      <el-row :gutter="16">
        <el-col :span="24">
          <el-form-item label="Status" prop="applymentStatus">
            <div class="bgWrap">
              <el-radio-group v-model="dataForm.applymentStatus">
                <el-radio label="ACRA_REJECTED">Rejected</el-radio>
                <el-radio label="FINISH">Pass</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Remark" prop="remark">
            <el-input
              v-model="dataForm.remark"
              type="textarea"
              :rows="4"
              :autosize="{ minRows: 3 }"
              resize="none"
              placeholder="Remark"
              v-regexFilter="halfWidthRegex"
            ></el-input>
          </el-form-item>
        </el-col>

        <!-- 未通过 -->
        <template v-if="dataForm.applymentStatus == 'ACRA_REJECTED'">
          <el-col :span="12">
            <el-form-item label="Attachments" prop="attachmentUrls">
              <el-multiple-file-uploader v-model="dataForm.attachmentUrls"></el-multiple-file-uploader>
            </el-form-item>
          </el-col>
        </template>

        <!-- 通过 -->
        <template v-if="dataForm.applymentStatus == 'FINISH'">
          <el-col :span="12">
            <el-form-item label="Incorporation/Transfer Time">
              <el-date-picker
                v-model="dataForm.incorporateTime"
                type="date"
                placeholder="Incorporation/Transfer Time"
                value-format="yyyy-MM-dd 00:00:00"
                class="fluid-width"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Renewal Time">
              <el-date-picker
                v-model="dataForm.renewalTime"
                type="date"
                placeholder="Renewal Time"
                value-format="yyyy-MM-dd 00:00:00"
                class="fluid-width"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Company Information Items" prop="companyInfoList">
              <div class="addBtnWrap">
                <el-button type="primary" icon="el-icon-plus" size="mini" plain @click="addHandle">Add Item</el-button>
              </div>
              <div class="itemListWrap">
                <el-row :gutter="10">
                  <el-col :span="5" class="itemTitle">Client Code</el-col>
                  <el-col :span="12" class="itemTitle">Company/Fund Manager Name</el-col>
                  <el-col :span="5" class="itemTitle">Biz Reg. No. (UEN)</el-col>
                </el-row>
                <div class="wdb100" v-for="(ele, index) in dataForm.companyInfoList" :key="`category-${index}`">
                  <el-row :gutter="10">
                    <el-col :span="5">
                      <el-form-item :prop="`companyInfoList.${index}.clientCode`">
                        <client-code-select-remote-search
                          v-model="ele.clientCode"
                          :showItems="['companyName', 'uen']"
                          placeholder="Client Code"
                          @change-item="data => clientCodeChange(data, ele)"
                        ></client-code-select-remote-search>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        :prop="`companyInfoList.${index}.companyName`"
                        :rules="{
                          required: dataRule.companyInfoList ? true : false,
                          message: 'please select',
                          trigger: 'submit',
                        }"
                      >
                        <el-input v-model="ele.companyName" clearable placeholder="Company/Fund Manager Name" v-regexFilter="halfWidthRegex"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item
                        :prop="`companyInfoList.${index}.uen`"
                        :rules="{
                          required: dataRule.companyInfoList ? true : false,
                          message: 'please select',
                          trigger: 'submit',
                        }"
                      >
                        <el-input v-model="ele.uen" clearable placeholder="Biz Reg. No. (UEN)"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2" class="tac">
                      <el-button type="danger" size="small" icon="el-icon-delete" plain @click="deleteHandle(index)"></el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Article of Association">
              <div class="bgWrap">
                <el-multiple-file-uploader v-model="dataForm.articlesOfIncorporationUrls"></el-multiple-file-uploader>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Biz/Gov File">
              <div class="bgWrap">
                <el-multiple-file-uploader v-model="dataForm.businessDocumentsUrls"></el-multiple-file-uploader>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Other Documents" prop="otherDocumentsUrls">
              <div class="bgWrap">
                <el-multiple-file-uploader v-model="dataForm.otherDocumentsUrls"></el-multiple-file-uploader>
              </div>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" plain :loading="saveLoading" :disabled="submitLoading" @click="dataFormSubmit(true)">Save</el-button>
      <el-button type="primary" :loading="submitLoading" :disabled="saveLoading" @click="dataFormSubmit(false)">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ClientCodeSelectRemoteSearch from "@/components/SelectRemoteSearch/clientCode";
import { mapActions } from "vuex";
export default {
  props: {
    detail: {
      type: Object,
      default: () => {
        return {
          statusDetail: {},
          acraCompanyInfoList: null, // 未创建时，为null；保存过后可为[]
          quotationList: [],
          businessType: null,
        };
      },
    },
  },
  components: {
    ClientCodeSelectRemoteSearch,
  },
  data() {
    return {
      visible: false,
      dataForm: {
        applymentStatus: "FINISH",
        remark: "",
        attachmentUrls: [],
        companyInfoList: [],
        incorporateTime: "",
        articlesOfIncorporationUrls: [],
        businessDocumentsUrls: [],
        otherDocumentsUrls: [],
        renewalTime: "",
      },
      // 当前激活的规则
      dataRule: {},
      // 提交时检验的规则
      submitRules: {
        companyInfoList: [{ type: "array", required: true, message: "please add", trigger: "submit" }],
      },
      saveLoading: false,
      submitLoading: false, // 防止重复提交
    };
  },
  methods: {
    ...mapActions("applyment", ["doAcraFeedback", "initApplyment"]),
    async init() {
      this.visible = true;
      this.saveLoading = false;
      this.submitLoading = false;
      // 重置校验规则，需要$nextTick()，不然会报错
      this.dataRule = this.submitRules;
      await this.$nextTick();
      // 需要手动设置为[],不然会报错
      this.$set(this.dataForm, "companyInfoList", []);
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();

      const detailCopy = JSON.parse(JSON.stringify(this.detail));
      const statusDetail = detailCopy?.statusDetail || {};
      let companyInfoList = [];
      if (["COMPREHENSIVE_CUSTOMIZED", "FUND_ADMIN_CUSTOMIZED"].includes(detailCopy.businessType)) {
        // 申请单是定制化类型时
        if (detailCopy.acraCompanyInfoList == null || detailCopy.acraCompanyInfoList == undefined) {
          // acraCompanyInfoList未创建时，需要自动填充quotationList(报价列表)中的client code 和 companyTitle
          const quotationList = detailCopy.quotationList || [];
          companyInfoList = quotationList.map(item => ({
            clientCode: item.clientCode,
            companyName: item.companyTitle,
            uen: "",
          }));
        } else {
          companyInfoList = detailCopy.acraCompanyInfoList || [];
        }
      } else {
        companyInfoList = detailCopy.acraCompanyInfoList || [];
      }
      this.dataForm = {
        applymentStatus: ["ACRA_REJECTED", "FINISH"].includes(statusDetail.applymentStatus) ? statusDetail.applymentStatus : "FINISH",
        remark: statusDetail.remark,
        attachmentUrls: statusDetail.attachmentUrls || [],
        companyInfoList,
        incorporateTime: statusDetail.incorporateTime,
        articlesOfIncorporationUrls: statusDetail.articlesOfIncorporationUrls || [],
        businessDocumentsUrls: statusDetail.businessDocumentsUrls || [],
        otherDocumentsUrls: statusDetail.otherDocumentsUrls || [],
        renewalTime: statusDetail.renewalTime,
      };
    },
    // 表单提交
    async dataFormSubmit(isSave) {
      const dataFormCopy = this.dataForm;
      const params = {
        applymentStatus: dataFormCopy.applymentStatus,
        remark: dataFormCopy.remark,
        onlyTemporarilySaved: isSave,
      };
      if (dataFormCopy.applymentStatus == "FINISH") {
        params.companyInfoList = dataFormCopy.companyInfoList;
        params.incorporateTime = dataFormCopy.incorporateTime;
        params.articlesOfIncorporationUrls = dataFormCopy.articlesOfIncorporationUrls;
        params.businessDocumentsUrls = dataFormCopy.businessDocumentsUrls;
        params.otherDocumentsUrls = dataFormCopy.otherDocumentsUrls;
        params.renewalTime = dataFormCopy.renewalTime;
      } else {
        params.attachmentUrls = dataFormCopy.attachmentUrls;
      }

      if (isSave) {
        // 保存时不检验必填项
        this.dataRule = {};
      } else {
        // 提交时需要检查必填项
        this.dataRule = this.submitRules;
      }
      await this.$nextTick();
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          if (isSave) {
            this.saveLoading = true;
          } else {
            await this.$confirm("Really ok?", "Warning", {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            });
            this.submitLoading = true;
          }
          this.doAcraFeedback(params)
            .then(async () => {
              console.log(123);
              // 更新申请单详情
              await this.initApplyment(this.detail.id);
              this.$message({
                message: "success",
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.visible = false;
                },
              });
            })
            .catch(msg => {
              console.log(msg)
              this.saveLoading = false;
              this.submitLoading = false;
            });
        }
      });
    },
    // Items - 添加
    addHandle() {
      this.dataForm.companyInfoList.push({
        clientCode: "",
        companyName: "",
        uen: "",
      });
    },
    // Items - 删除
    deleteHandle(index) {
      this.dataForm.companyInfoList.splice(index, 1);
    },
    // Client Code 选中时自动填充对应信息
    clientCodeChange(data, ele) {
      if (!data) return;
      ele.uen = data.uen || "";
      ele.companyName = data.companyName || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.bgWrap {
  padding: 2px 4px;
  background: #f5f7fa;
  border-radius: 2px;
}

.addBtnWrap {
  text-align: right;
  margin-top: -32px;
}

.itemListWrap {
  margin-top: 8px;
  padding: 0px 6px;
  background: #f5f7fa;
  border-radius: 2px;

  .itemTitle {
    font-size: 13px;
    text-align: center;
  }

  .notSelectTipBg {
    padding: 6px 10px;
    background: #f5f7fa;
    border-radius: 2px;
  }
}
</style>
